import React, { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxContainer,
    BoxTitle,
    Underline,
    BoxHead,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import Table from "../../Components/Properties/VacancyReport/Table";
import SingleDatePicker from "../../Components/SingleDatePicker";
import SideModal from "../../Components/SideModal";
import FilterModal from "../../Components/Properties/VacancyReport/FilterModal";
import { IoFilter } from "react-icons/io5";
import LocationsFilterDropdown from "../../Components/LocationsFilterDropdown";
import { Select_Location, Select_Property } from "../../Redux/actions";


const VacancyByProperty = () => {
    const dispatch = useDispatch();
    const properties = useSelector((state) => state.PropertyReducer.property);
    const locations = useSelector((state) => state.LocationsReducer.locations);

    const user = useSelector((state) => state.UserReducer.user);
    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const location = useSelector(
        (state) => state.SelectLocationReducer.selectLocation
    );
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterType, setFilterType] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const [apiData, setApiData] = useState();
    const [masterData, setMasterData] = useState();
    const [filterData, setFilterData] = useState();
    const [selectedProperty, setSelectedProperty] = useState(property);
    const defaultLocations = {
        id: 0,
        name: "All Locations",
        clientId: 0,
    };
    const [selectedLocation, setSelectedLocation] = useState(location);

    const btnRef = useRef(null);
    const [startDate, setStartDate] = useState(
        moment().format("YYYY-MM-DD")
    );
    const [activeFilter, setActiveFilter] = useState(false);
    const query = `&checkDate=${startDate}&propId=${selectedProperty?.id}&s=${searchQuery}&t=${filterType}&locationId=${selectedLocation?.id}`;

    const fetchFunction = async () => {
        const response = await axios.get(`${Config.apiUrl}/client/list/bed/stats?${query}`, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess === false) error = true;
        else {
            setApiData(res?.newData);
            setMasterData(res?.newData);
            const vacantBedsSummary = getVacantBedsByProperty(res?.newData);
            setFilterData(vacantBedsSummary);
            setIsFocused(true);
        }
    };

    const getError = (res) => { };

    const {
        isLoading: isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        if (selectedProperty || selectedLocation) {
            const handler = setTimeout(() => {
                getListMutate();
            }, 50);
            return () => {
                clearTimeout(handler);
            };
        }
    }, [selectedProperty, selectedLocation]);

    const submitHandler = (date) => {
        const formattedDate = moment(date).format("YYYY-MM-DD");
        setStartDate(formattedDate);
        const handler = setTimeout(() => {
            getListMutate();
        }, 50);
        return () => {
            clearTimeout(handler);
        };
    };

    const handlePropertySelect = (property) => {
        dispatch(Select_Location(defaultLocations));
        setSelectedProperty(property);
        setSelectedLocation(defaultLocations)

    };

    const handleLocationSelect = (location) => {
        dispatch(Select_Property({ id: 0, name: "All Properties", type: 0, gId: "KIPINN" }));
        setSelectedLocation(location);
        setSelectedProperty({ id: 0, name: "All Properties", type: 0, gId: "KIPINN" })
    };
    
    const getVacantBedsByProperty = (
        data,
        filters = {
            tenantPreference: null,   // number | null
            amenities: [],            // array of strings
            roomSharing: null         // number | null (1 = single, 2 = double, 3 = triple, etc.)
        }
    ) => {
        let grandTotalVacantBeds = 0;
        const properties = Object.entries(data)
            .map(([propertyId, property]) => {

                // ---- Property-level filter: Tenant Preference ----
                if (
                    filters.tenantPreference &&
                    property.tenantPreference !== filters.tenantPreference
                ) {
                    return null;
                }

                let totalVacantBeds = 0;

                Object.values(property.floors).forEach(floor => {
                    Object.values(floor).forEach(room => {

                        // ---- Skip fully occupied rooms ----
                        if (!room.vacantBeds || Number(room.vacantBeds) === 0) {
                            return;
                        }

                        // ---- Room-sharing filter (1 bed, 2 beds, 3 beds...) ----
                        if (
                            filters.roomSharing &&
                            Number(room.totalBeds) !== Number(filters.roomSharing)
                        ) {
                            return;
                        }

                        // ---- Amenities filter (room must contain ALL selected amenities) ----
                        if (filters.amenities?.length) {
                            const roomAmenities = room.amenities
                                ?.split(",")
                                .map(a => a.trim().toLowerCase()) || [];

                            const hasAllAmenities = filters.amenities.every(a =>
                                roomAmenities.includes(a.toLowerCase())
                            );

                            if (!hasAllAmenities) {
                                return;
                            }
                        }

                        // ---- Count valid vacant beds ----
                        totalVacantBeds += Number(room.vacantBeds);
                    });
                });

                if (totalVacantBeds === 0) return null;

                grandTotalVacantBeds += totalVacantBeds;
                return {
                    propertyId,
                    id: propertyId,
                    name: property.propName,
                    gId: property.gId,
                    address: property.propAddress,
                    vacantBeds: totalVacantBeds,
                    tenantPreference: property.tenantPreference,
                    type: property.propType,
                };
            })

            // ---- Remove null entries ----
            .filter(Boolean);

        return {
            properties,
            totalVacantBeds: grandTotalVacantBeds,
        };
    };

    const onApplyFilter = (value, label, type) => {
        if (type === 1) {
            const filteredData = getVacantBedsByProperty(apiData, { tenantPreference: Number(value) });
            setFilterData(filteredData);
        }
        else if (type === 2) {
            const filteredData = getVacantBedsByProperty(masterData, { amenities: [value] });
            setFilterData(filteredData);
        }
        else if (type === 3) {
            const filteredData = getVacantBedsByProperty(masterData, { roomSharing: Number(value) });
            setFilterData(filteredData);
        }
        setIsFilterOpen(false);
        setActiveFilter(true);
    };

    const handleFilterClose = () => {
        setIsFilterOpen(false);
        setActiveFilter(false);
        const filteredData = getVacantBedsByProperty(masterData);
        setFilterData(filteredData);
    };



    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        Vacancy By Property
                        <Underline />
                    </BoxTitle>
                </BoxHead>

                <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
                    <FilterModal
                        onApplyFilter={onApplyFilter}
                        handleClose={handleFilterClose}
                    />
                </SideModal>

                <FilterTableWrapper>
                    <FilterWrapper className="grid grid-cols-1 md:grid-cols-[auto_1fr]  gap-4">
                        <div className="flex items-center">
                            <Text>
                                Vacant Beds:{" "}
                                <span className="font-semibold">
                                    {filterData?.totalVacantBeds || 0}
                                </span>
                            </Text>
                        </div>
                        <div className="flex gap-2 justify-end items-center">
                            <SingleDatePicker
                                submitHandler={submitHandler}
                                defaultLabel={moment(startDate).format("YYYY-MM-DD")}
                                initialDate={startDate}
                                minDate={new Date()}
                                maxDate={moment().add(1, "year").toDate()}
                            />
                            <PropertiesFilterDropdown
                                properties={properties}
                                selectedProperty={selectedProperty}
                                onPropertySelect={handlePropertySelect}
                                placeholder="Select Property"
                                className="min-w-[200px]"
                            />
                            <LocationsFilterDropdown
                                locations={locations}
                                selectedLocation={selectedLocation}
                                onSelect={handleLocationSelect}
                                placeholder="All Locations"
                                className="w-full md:w-[200px]"
                            />
                            <div className="relative">
                                <FilterBtn
                                    ref={btnRef}
                                    type="button"
                                    title="Category Filter"
                                    onClick={() => setIsFilterOpen((v) => !v)}
                                    className={`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto}`}
                                >
                                    <IoFilter size={14} color="#9CA3AF" />
                                </FilterBtn>
                                {/* Yellow dot when filter is applied */}
                                {activeFilter && (
                                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"></span>
                                )}
                            </div>
                        </div>
                    </FilterWrapper>
                    {/* {apiData && <VacancyReportView apiData={apiData} />} */}
                    {!error && !isLoading && data && (
                        <TableWrapper>
                            <Table
                                apiData={filterData?.properties}
                            />
                        </TableWrapper>
                    )}
                </FilterTableWrapper>

                {error && !isLoading && <NotFoundModel />}
                {(isLoading || isRefetching) && <Loading />}
            </BoxContainer>
        </>
    );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button``;
const Summary = tw.div`bg-rose-100 px-4 py-2 items-center rounded-br-lg md:mb-6 mb-2`;
const Text = tw.p`text-xs text-rose-500 font-semibold `;

export default VacancyByProperty;
